import React, { useContext } from 'react';
import { useFlag } from '../redux/flags/hooks/useFlag';
import classnames from 'classnames';
import { withMatureContext, SessionContext } from '../Context';
import s from './LegacyTextRenderer.scss';
function createMarkup(text) {
    return { __html: text };
}
export var LegacyTextRenderer = function (_a) {
    var html = _a.html, className = _a.className, theme = _a.theme, showMatureContent = _a.showMatureContent, disableStyles = _a.disableStyles;
    var v2 = useFlag('comment_v2');
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    if (!html) {
        return null;
    }
    return (React.createElement("div", { className: classnames('legacy-journal', !isLoggedIn && 'loggedout', !disableStyles && theme && s['legacy'], !disableStyles && theme && s[theme], theme === 'comments' && v2 && s['commentv2'], !showMatureContent && 'maturefilter', className), dangerouslySetInnerHTML: createMarkup(html) }));
};
LegacyTextRenderer.displayName = 'LegacyTextRenderer';
export default withMatureContext(LegacyTextRenderer);
//# sourceMappingURL=LegacyTextRenderer.js.map